var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDiscountIcon = function SvgDiscountIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5889C21 18.7778 18.7778 21 11 21C3.22222 21 1 18.7778 1 11C1 3.22222 3.22222 1 11 1C18.7778 1 21 3.22222 21 11.5889Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66669 14.3333L14.3334 7.66663",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7778 14.3333C14.0889 14.3333 14.3333 14.0888 14.3333 13.7777C14.3333 13.4666 14.0889 13.2222 13.7778 13.2222C13.4667 13.2222 13.2222 13.4666 13.2222 13.7777C13.2222 14.0888 13.4667 14.3333 13.7778 14.3333Z",
    fill: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22224 8.77774C8.53335 8.77774 8.7778 8.53329 8.7778 8.22218C8.7778 7.91107 8.53335 7.66663 8.22224 7.66663C7.91113 7.66663 7.66669 7.91107 7.66669 8.22218C7.66669 8.53329 7.91113 8.77774 8.22224 8.77774Z",
    fill: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiscountIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/discount_icon.7201e39f.svg";
export { ForwardRef as ReactComponent };